"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Animation = void 0;
var Animation;
exports.Animation = Animation;

(function (Animation) {
  Animation["SLIDELEFT"] = "slideLeft";
  Animation["SLIDERIGHT"] = "slideRight";
  Animation["SLIDEUP"] = "slideUp";
})(Animation || (exports.Animation = Animation = {}));